module.exports = __webpack_public_path__ + "img/spin_btn.87a1db03.png";